import { useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { TablePage } from 'CorePackage/TableModule/components/TablePage';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';

import { initialDecisionTableColumns } from '../constants/initialDecisionTableColumns';
import { IDecisionListItem } from '../interfaces/IDecisionListItem';
import { decisionListInitPage } from '../actions/decisionListActions';
import { getDecisionListData } from '../selectors/decisionListSelectors';
import { DecisionListPanel } from './DecisionListPanel';
import { DecisionsTable } from './DecisionsTable';

interface IDecisionListProps {
  decisions: IDecisionListItem[];
}

const DecisionListWithoutStore = ({ decisions }: IDecisionListProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const [itemsCheck, setItemsCheck] = useState<TableCheckItems>({});
  const [searchInputValue, setSearchInputValue] = useState('');
  const [tableColumns, setTableColumns] = useState(initialDecisionTableColumns);

  useEffect(() => {
    const newItemsCheck: TableCheckItems = {};

    decisions.forEach(decision => {
      newItemsCheck[String(decision.id)] = false;
    });
    setItemsCheck(newItemsCheck);
  }, [decisions]);

  useEffectOnce(() => {
    dispatch(decisionListInitPage());
  });

  return (
    <TablePage>
      <DecisionListPanel
        itemsCheck={itemsCheck}
        searchInputValue={searchInputValue}
        setSearchInputValue={setSearchInputValue}
      />
      <DecisionsTable
        columns={tableColumns}
        itemsCheck={itemsCheck}
        setItemsCheck={setItemsCheck}
        setTableColumns={setTableColumns}
      />
    </TablePage>
  );
};

const mapStateToProps = (state: IRootState): IDecisionListProps => ({
  decisions: getDecisionListData(state),
});

export const DecisionList = connect(mapStateToProps)(DecisionListWithoutStore);
